var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74977 14.7502c-.16667-.1666-.24653-.3646-.23959-.5937.00695-.2292.08681-.4202.23959-.5729L7.1456 9.12522c.31944-.31944.71528-.47916 1.1875-.47916s.86806.15972 1.1875.47916l2.1458 2.16668 4.3334-4.29168h-1.3334c-.2361 0-.434-.07986-.5937-.23958-.1597-.15972-.2396-.35764-.2396-.59375s.0799-.43403.2396-.59375c.1597-.15972.3576-.23958.5937-.23958h3.3334c.2361 0 .434.07986.5937.23958.1597.15972.2396.35764.2396.59375v3.33333c0 .23611-.0799.43403-.2396.59378-.1597.1597-.3576.2396-.5937.2396-.2361 0-.4341-.0799-.5938-.2396-.1597-.15975-.2396-.35767-.2396-.59378V8.16689l-4.3125 4.31251c-.3194.3194-.7152.4792-1.1875.4792-.4722 0-.868-.1598-1.1875-.4792l-2.1458-2.1458-4.41667 4.4166c-.15278.1528-.34722.2292-.58333.2292-.23611 0-.43056-.0764-.58333-.2292Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.fcbbb09868981b7598cd6e53c76b32ef.svg";
export { ForwardRef as ReactComponent };